// extracted by mini-css-extract-plugin
module.exports = {"server_levels":"serverLevels_server_levels__PfOdX","table_block":"serverLevels_table_block__2DkAg","wrap_block":"serverLevels_wrap_block__zqDLy"};